export const base = '/appeal';

export const tab__id = `${base}/:tab/:id`;
export const filter__id = `${base}/filter/:filterId`;